import { ReactElement } from "react";
import { getAmazonList, useInit } from "./logic"
import Card from '@material-ui/core/Card';
import InfiniteScroll from "react-infinite-scroll-component";

function Page(): ReactElement {
    const { classes, books, setBooks, lastVisible, setLastVisible, setHasMore, hasMore } = useInit();

    return (
        <InfiniteScroll dataLength={books.length} next={() => getAmazonList(lastVisible, setLastVisible, setBooks, setHasMore)} hasMore={hasMore} loader={<h4>Loading...</h4>}>
            <div className={classes.cardInfoErea}>
                {books?.map((book, index) => (
                    <Card className={classes.card} key={index + book.id}>
                        <a href={book.detail_page_url} target="_blank" rel="noreferrer noopener">
                            <img className={classes.img} src={book.image_url} alt={book.title} />
                        </a>
                        <Card>
                            <ul className={classes.cardInfo}>
                                <li>{book.title}</li>
                                <li>{book.author}</li>
                                {book.author ? <li>{book.manufacturer}</li> : null}
                                <li>{book.isbn10}</li>
                            </ul>
                        </Card>
                    </Card>
                ))}
            </div>
        </InfiniteScroll>
    )
}

function parent() {
    return (
        <Page />
    )
}

export default parent;


